import { render } from "./SliderToggle.vue?vue&type=template&id=bc0b8e0c&scoped=true&ts=true"
import script from "./SliderToggle.vue?vue&type=script&lang=ts"
export * from "./SliderToggle.vue?vue&type=script&lang=ts"

import "./SliderToggle.vue?vue&type=style&index=0&id=bc0b8e0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc0b8e0c"]])

export default __exports__